import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AnnuairePosteFilterParams } from '@models/api/requests';

@Injectable({
  providedIn: 'root'
})
export class PostesService {
  private readonly apiUrl = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private readonly http: HttpClient) {}
  addAnnuairePosteFilterParams(params: HttpParams, filters: AnnuairePosteFilterParams | null | undefined): HttpParams {
    if (!filters) return params;

    if (filters.agent) params = params.set('detenteur.id', filters.agent);
    if (filters.fonction) params = params.set('detenteur.fonction', filters.fonction);
    if (filters.structureHierarchique) params = params.set('detenteur.structure', filters.structureHierarchique);

    if (filters.dateDebutContrat?.isValid) {
      const startDate = filters.dateDebutContrat.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateDebutContrat.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('detenteur.dateDebutContratStart', startDate);
      params = params.set('detenteur.dateDebutContratEnd', endDate);
    }

    if (filters.dateFinContrat?.isValid) {
      const startDate = filters.dateFinContrat.set({ hour: 0, minute: 0, second: 0 }).toFormat('yyyy-MM-dd');
      const endDate = filters.dateFinContrat.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd');
      params = params.set('detenteur.dateFinContratStart', startDate);
      params = params.set('detenteur.dateFinContratEnd', endDate);
    }

    if (filters.service) params = params.set('serviceFonctionnel', filters.service);
    if (filters.direction) params = params.set('direction', filters.direction);
    if (filters.posteBudgete !== null) params = params.set('budgete', filters.posteBudgete.toString());
    if (filters.vacantPourvu !== null) params = params.set('occupation', filters.vacantPourvu.toString());
    if (filters.typeCT) params = params.set('detenteur.typeContrat', filters.typeCT.toString());
    if (filters.intitulePoste) params = params.set('libelle', filters.intitulePoste);
    if (filters.numeroPoste) params = params.set('code', filters.numeroPoste);
    if (filters.agentRemplace) params = params.set('detenteur.agentRemplaceNom', filters.agentRemplace);
    if (filters.categorieGrade) params = params.set('categoriePoste', filters.categorieGrade.toString());
    if (filters.tauxEmploi) {
      params = params.set('tauxEmploi', filters.tauxEmploi.toString());
    }
    if (filters.ageAgent) params = params.set('detenteur.age', filters.ageAgent);
    if (filters.nombreAgent) params = params.set('detenteur.nombre', filters.nombreAgent);
    if (filters.matriculeAgent) params = params.set('detenteur.matricule', filters.matriculeAgent);

    return params;
  }
  getAllPostes(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/postes/all`);
  }

  getPostesByDirection(directionId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/postes?direction=${directionId}`);
  }

  getPostesByService(serviceId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/postes?service=${serviceId}`);
  }

  getPostesByService2(serviceId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/postes?service=${serviceId}`);
  }

  getAnnuairePoste(offset: number, limit: number, filters?: AnnuairePosteFilterParams | null) {
    let params = new HttpParams().set('page', offset.toString()).set('size', limit.toString());
    params = this.addAnnuairePosteFilterParams(params, filters);
    return this.http.get<any>(`${this.apiUrl}/postes`, { params });
  }
}
